module.exports = __webpack_public_path__ + "img/block1.19678dd1.png";